import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';

// Pages
import Home from './pages/Home';
import YurtIciSatis from './pages/YurtIciSatis';
import VarlikYonetimi from './pages/VarlikYonetimi';
import KurumsalFinansman from './pages/KurumsalFinansman';
import BiziTaniyin from './pages/BiziTaniyin';
import Iletisim from './pages/Iletisim';
import Kariyer from './pages/Kariyer';
import InternetSubesi from './pages/InternetSubesi';
import GenericAboutPage from './pages/GenericAboutPage';
import GizlilikPolitikasi from './pages/GizlilikPolitikasi';

import Basvurmak from './pages/Basvurmak';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          
          {/* Products & Services */}
          <Route path="/urun-ve-hizmetler/yurt-ici-satis" element={<YurtIciSatis />} />
          <Route path="/urun-ve-hizmetler/yurt-ici-satis/*" element={<YurtIciSatis />} />
          <Route path="/urun-ve-hizmetler/varlik-yonetimi" element={<VarlikYonetimi />} />
          <Route path="/urun-ve-hizmetler/kurumsal-finansman" element={<KurumsalFinansman />} />
          
          {/* About */}
          <Route path="/hakkimizda/bizi-taniyin" element={<BiziTaniyin />} />
          <Route path="/hakkimizda/tarihce" element={<GenericAboutPage />} />
          <Route path="/hakkimizda/misyon-vizyon" element={<GenericAboutPage />} />
          <Route path="/hakkimizda/kurumsal-degerlerimiz" element={<GenericAboutPage />} />
          <Route path="/hakkimizda/kurumsal-yonetim" element={<GenericAboutPage />} />
          <Route path="/hakkimizda/rapor" element={<GenericAboutPage />} />
          <Route path="/hakkimizda/istiraklerimiz" element={<GenericAboutPage />} />
          <Route path="/hakkimizda/haberler" element={<GenericAboutPage />} />
          
          {/* Other Pages */}
          <Route path="/internet-subesi" element={<InternetSubesi />} />
          <Route path="/iletisim" element={<Iletisim />} />
          <Route path="/kariyer" element={<Kariyer />} />
          <Route path="/basvurmak" element={<Basvurmak />} />
          
          {/* Legal */}
          <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
          <Route path="/kullanim-kosullari" element={<GizlilikPolitikasi />} />
          <Route path="/cerez-politikasi" element={<GizlilikPolitikasi />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
